import type { SeoHelmetProps } from '@app/domains/common/components/SeoHelmet';

const HOME_ORGANIZATION_SCHEMA = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: process.env.VITE_REACT_APP_SITE,
    logo: `${process.env.VITE_REACT_APP_SITE}/images/logo.jpg`,
    name: 'Wuxiaworld',
    legalName: 'Wuxiaworld Ltd.',
    contactPoint: [{ '@type': 'ContactPoint', email: 'contactus@wuxiaworld.com', contactType: 'customer support' }],
    sameAs: [
        'https://twitter.com/Wuxiaworld_Ltd',
        'https://www.facebook.com/people/Wuxiaworld/100064118106726/',
        'https://discord.gg/wuxiaworld',
        'https://apps.apple.com/us/app/wuxiaworld/id1503356244?mt=8',
        'https://play.google.com/store/apps/details?id=com.wuxiaworld.mobile&hl=en_US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
    ],
};

const HOME_BREADCRUMB_SCHEMA = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
        {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: process.env.VITE_REACT_APP_SITE,
        },
    ],
};

const HOME_SITE_NAVIGATION_SCHEMA = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    itemListElement: [
        {
            '@type': 'SiteNavigationElement',
            position: 1,
            name: 'Home',
            description:
                'Wuxiaworld is the foremost English publisher of Chinese and Korean fantasy webnovels and light novels',
            url: process.env.VITE_REACT_APP_SITE,
        },
        {
            '@type': 'SiteNavigationElement',
            position: 2,
            name: 'Novels',
            description:
                'From Chinese novels to Korean novels to Light novels, you can experience the best Wuxia novels. Check out all genres such as fantasy, action, and so on!',
            url: `${process.env.VITE_REACT_APP_SITE}/novels`,
        },
        {
            '@type': 'SiteNavigationElement',
            position: 3,
            name: 'Updates',
            description: 'View our most recently updated novels',
            url: `${process.env.VITE_REACT_APP_SITE}/updates`,
        },
        {
            '@type': 'SiteNavigationElement',
            position: 4,
            name: 'Overgeared',
            description:
                "'Overgeared' is a fantasy, sci-fi, action Korean web novel. Read the chapters on 'Overgeared' from Wuxiaworld.",
            url: `${process.env.VITE_REACT_APP_SITE}/novel/overgeared`,
        },
        {
            '@type': 'SiteNavigationElement',
            position: 5,
            name: 'Translator Announcements',
            description: 'Read the latest Wuxiaworld updates and news',
            url: `${process.env.VITE_REACT_APP_SITE}/announcements`,
        },
    ],
};

export const HOME_PAGE_META_DATA = {
    title: 'Wuxiaworld | Read Fantasy Novels',
    description:
        'Wuxiaworld is the foremost English publisher of Chinese and Korean fantasy webnovels and light novels',
    keywords: 'best webnovel, webnovel site, best fantasy novels, best light novels, wuxiaworld',
    siteUrl: '/',
    schemas: [HOME_ORGANIZATION_SCHEMA, HOME_BREADCRUMB_SCHEMA, HOME_SITE_NAVIGATION_SCHEMA],
} as SeoHelmetProps;
